export const Cep = {
  get: (cep) => {
    return fetch(`https://viacep.com.br/ws/${cep}/json/`)
      .then(response => response.json())
      .then(data => data)
      .catch(error => console.log(error))
  }
}